import React, { Component, useState, Fragment, useEffect, useMemo, useRef } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import GrainIcon from '@mui/icons-material/Grain';
import LightModeIcon from '@mui/icons-material/LightMode';
import Checkbox from '@mui/material/Checkbox';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { AppBar, Toolbar, Typography, Button, IconButton, Modal, Grid, Box, TextField, FormControl, InputLabel, Drawer, Menu, Paper, Divider } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Card from '@material-ui/core/Card';
import SearchIcon from '@material-ui/icons/Search';
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import { PostAddOutlined } from '@mui/icons-material';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { customTheme, getColorfont, getColor } from '../../../StyleComponents/Styledatatable';
import classNames from 'classnames';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AccordionSummary from '@mui/material/AccordionSummary';
import SettingsIcon from '@mui/icons-material/Settings';
import useStyles from '../../../StyleComponents/StyleFunctionComponent';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Popover from '@mui/material/Popover';
import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined';
import { API_BASE_URL, token, userLevel, adminId } from '../../../../constants';

const AllUsers = () => {
    const history = useHistory();
    const [openSidebar, setOpenSidebar] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [perPage, setPerPage] = useState(50);
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);
    const [fromDate, setFromDate] = useState(sevenDaysAgo.toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(currentDate.toISOString().split('T')[0]);
    const [executiveOptions, setExecutiveOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState();
    const [brandOptions, setBrandOptions] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [excutiveassign, setExcutiveAssign] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const [updatedData, setUpdatedData] = useState({
        status: '',
    });
    const [brands, setBrands] = useState([]);
    const [doubleClickedRow, setDoubleClickedRow] = useState(null);
    const [message, setMessage] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [campaignOptions, setCampaignOptions] = useState([]);
    // Create User Modal
    const [openCreateUserModal, setOpenCreateUserModal] = useState(false);
    const [openAssignRoleModal, setOpenAssignRoleModal] = useState(false);
    const [selectedAdminId, setSelectedAdminId] = useState(null);
    const [moduleList, setModuleList] = useState([]);
    const [selectedModules, setSelectedModules] = useState([]);
    // Assign Brand Modal
    const [openAssignBrandModal, setOpenAssignBrandModal] = useState(false);
    const [assignBrandAdminId, setAssignBrandAdminId] = useState(null);
    const [assignBrandOptions, setAssignBrandOptions] = useState([]);
    const [selectedAssignBrands, setSelectedAssignBrands] = useState([]);
    // Update Password Modal
    const [openPasswordModal, setOpenPasswordModal] = useState(false);
    const [passwordAdminId, setPasswordAdminId] = useState(null);
    const [openUpdateUserModal, setOpenUpdateUserModal] = useState(false);
    const [updateUserAdminId, setUpdateUserAdminId] = useState(null);
    // @@@@@@@@@@@@@@@@@@@


    const handleUpdateUserChange = (e) => {
        const { name, value } = e.target;
        setUpdateUserForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const [updateUserForm, setUpdateUserForm] = useState({
        username: "",
        admin_email: "",
        user_level: "",
    });
    const [passwordForm, setPasswordForm] = useState({
        new_password: "",
        confirm_password: "",
    });
    const [createUserForm, setCreateUserForm] = useState({
        username: "",
        admin_email: "",
        user_level: "",
    });
    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleOpenPasswordModal = (adminId) => {
        setPasswordAdminId(adminId);
        setPasswordForm({
            new_password: "",
            confirm_password: "",
        });
        setOpenPasswordModal(true);
    };

    const handleCreateUserChange = (e) => {
        const { name, value } = e.target;
        setCreateUserForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleOpenUpdateUserModal = async (adminIdValue) => {
        try {
            setUpdateUserAdminId(adminIdValue);

            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };

            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/edit-admin-user/${adminIdValue}`,
                {},
                config
            );

            const userData = response?.data?.data || {};

            setUpdateUserForm({
                username: userData.username || "",
                admin_email: userData.admin_email || "",
                user_level: userData.user_level || "",
            });

            setOpenUpdateUserModal(true);
        } catch (error) {
            console.error(error);

            setSnackbarMessage(
                error?.response?.data?.message ||
                "Failed to load user details"
            );

            setSnackbarOpen(true);
        }
    };

    const handleUpdateUserSubmit = async () => {
        // Username Validation
        if (
            !updateUserForm.username ||
            updateUserForm.username.trim() === ""
        ) {
            setSnackbarMessage("Please enter User Name");
            setSnackbarOpen(true);
            return;
        }

        // Email Validation
        if (
            !updateUserForm.admin_email ||
            updateUserForm.admin_email.trim() === ""
        ) {
            setSnackbarMessage("Please enter Email");
            setSnackbarOpen(true);
            return;
        }

        // Email Format Validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(updateUserForm.admin_email)) {
            setSnackbarMessage("Please enter a valid Email Address");
            setSnackbarOpen(true);
            return;
        }


        try {
            setIsLoading(true);

            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };

            const payload = {
                admin_id: updateUserAdminId,
                username: updateUserForm.username,
                admin_email: updateUserForm.admin_email,
                user_level: updateUserForm.user_level,
            };

            console.log("Update User Payload :", payload);

            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/admin-user-create/${updateUserAdminId}`,
                payload,
                config
            );

            setSnackbarMessage(
                response?.data?.message ||
                "User updated successfully"
            );

            setSnackbarOpen(true);
            setOpenUpdateUserModal(false);

            fetchData();
        } catch (error) {
            console.error(error);

            setSnackbarMessage(
                error?.response?.data?.message ||
                "Failed to update user"
            );

            setSnackbarOpen(true);
        } finally {
            setIsLoading(false);
        }
    };


    const handlePasswordSubmit = async () => {
        if (!passwordForm.new_password) {
            setSnackbarMessage("Please enter new password");
            setSnackbarOpen(true);
            return;
        }
        if (!passwordForm.confirm_password) {
            setSnackbarMessage("Please enter confirm password");
            setSnackbarOpen(true);
            return;
        }
        if (
            passwordForm.new_password !==
            passwordForm.confirm_password
        ) {
            setSnackbarMessage("Password and Confirm Password must match");
            setSnackbarOpen(true);
            return;
        }
        try {
            setIsLoading(true);
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };
            const payload = {
                admin_id: passwordAdminId,
                new_password: passwordForm.new_password,
                confirm_password: passwordForm.confirm_password,
            };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/change-password`,
                payload,
                config
            );
            setSnackbarMessage(
                response?.data?.message ||
                "Password updated successfully"
            );
            setSnackbarOpen(true);
            setOpenPasswordModal(false);

        } catch (error) {
            console.error(error);
            setSnackbarMessage(
                error?.response?.data?.message ||
                "Failed to update password"
            );
            setSnackbarOpen(true);
        } finally {
            setIsLoading(false);
        }
    };

    const handleOpenAssignBrandModal = async (adminIdValue) => {
        try {
            setAssignBrandAdminId(adminIdValue);

            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };

            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/user-assign-brands/${adminIdValue}`,
                {},
                config
            );

            // Dropdown Brand List
            const brandList =
                response?.data?.data?.tractorBrands?.map((item) => ({
                    id: Number(item.brand_id),
                    title: item.brand_name,
                })) || [];

            // Auto Selected Assigned Brands
            const assignedBrands =
                response?.data?.data?.adminBrands?.map((item) => ({
                    id: Number(item.brand?.brand_id),
                    title: item.brand?.brand_name,
                })) || [];

            setAssignBrandOptions(brandList);
            setSelectedAssignBrands(assignedBrands);

            setOpenAssignBrandModal(true);
        } catch (error) {
            console.error(error);

            setSnackbarMessage(
                error?.response?.data?.message ||
                "Failed to load assigned brands"
            );

            setSnackbarOpen(true);
        }
    };

    const handleAssignBrandSubmit = async () => {
        try {
            setIsLoading(true);
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };
            const payload = {
                admin_id: assignBrandAdminId,
                brand_id: selectedAssignBrands.map(item => item.id),
            };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/insert-assign-brands`,
                payload,
                config
            );
            setSnackbarMessage(
                response?.data?.message || "Brands updated successfully"
            );
            setSnackbarOpen(true);
            setOpenAssignBrandModal(false);
            fetchData();
        } catch (error) {
            console.error(error);
            setSnackbarMessage(
                error?.response?.data?.message ||
                "Failed to update brands"
            );
            setSnackbarOpen(true);
        } finally {
            setIsLoading(false);
        }
    };
    const handleOpenAssignRoleModal = async (adminIdValue) => {
        try {
            setSelectedAdminId(adminIdValue);

            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };

            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/admin-user/assign-roles/${adminIdValue}`,
                {},
                config
            );

            // All available modules
            const allModules =
                response?.data?.data?.modules?.map((item) => ({
                    id: item.id,
                    title: item.module,
                })) || [];

            // Already assigned modules
            const assignedModules =
                response?.data?.data?.adminUser?.admin_access?.map((item) => ({
                    id: item.module.id,
                    title: item.module.module,
                })) || [];

            setModuleList(allModules);
            setSelectedModules(assignedModules);

            setOpenAssignRoleModal(true);
        } catch (error) {
            console.error(error);

            setSnackbarMessage(
                error?.response?.data?.message ||
                "Failed to load assigned roles"
            );
            setSnackbarOpen(true);
        }
    };
    const handleModuleChange = (event, value) => {
        setSelectedModules(value);
    };
    const handleAssignRolesSubmit = async () => {
        try {
            setIsLoading(true);
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };

            const payload = {
                admin_id: selectedAdminId,
                modules: selectedModules.map((item) => item.id),
            };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/admin-user/assign-roles/${selectedAdminId}`,
                payload,
                config
            );

            setSnackbarMessage(
                response?.data?.message ||
                "Roles updated successfully"
            );
            setSnackbarOpen(true);

            setOpenAssignRoleModal(false);
            fetchData();
        } catch (error) {
            console.error(error);

            setSnackbarMessage(
                error?.response?.data?.message ||
                "Failed to assign roles"
            );
            setSnackbarOpen(true);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCreateUserSubmit = async () => {
        // Username Validation
        if (
            !createUserForm.username ||
            createUserForm.username.trim() === ""
        ) {
            setSnackbarMessage("Please enter User Name");
            setSnackbarOpen(true);
            return;
        }

        // Email Validation
        if (
            !createUserForm.admin_email ||
            createUserForm.admin_email.trim() === ""
        ) {
            setSnackbarMessage("Please enter Email");
            setSnackbarOpen(true);
            return;
        }

        // Email Format Validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(createUserForm.admin_email)) {
            setSnackbarMessage("Please enter a valid Email Address");
            setSnackbarOpen(true);
            return;
        }

        // User Level Validation
        if (
            !createUserForm.user_level ||
            createUserForm.user_level.trim() === ""
        ) {
            setSnackbarMessage("Please select User Level");
            setSnackbarOpen(true);
            return;
        }

        try {
            setIsLoading(true);
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };
            const payload = {
                username: createUserForm.username,
                admin_email: createUserForm.admin_email,
                user_level: createUserForm.user_level || "",
            };

            console.log("Create Admin User Payload:", payload);

            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/admin-user-create`,
                createUserForm,
                config
            );
            setSnackbarMessage(response?.data?.message || "User created successfully");
            setSnackbarOpen(true);
            setOpenCreateUserModal(false);
            setCreateUserForm({
                username: "",
                admin_email: "",
                user_level: "",
            });
            fetchData(); // refresh table
        } catch (error) {
            console.error(error);
            setSnackbarMessage(
                error?.response?.data?.message || "Failed to create user"
            );
            setSnackbarOpen(true);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const fetchDatabrand = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity, // Request will never time out
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.brand_id,
                    title: item.brand_name,
                }));
                setBrandOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatabrand();
    }, []);



    useEffect(() => {
        const fetchDatalist = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/executive-list`, config);
                const filteredData = response.data.data.filter(item => item.status === 1);
                const mappedData = filteredData.map(item => ({
                    id: item.admin_id,
                    title: item.username,
                }));
                const optionsWithNull = [
                    // { id: null, title: 'Select Executive' },
                    ...mappedData,
                ];
                setExecutiveOptions(optionsWithNull);
            } catch (error) {
                console.error('Error fetching executives:', error);
            }
        };
        fetchDatalist();
    }, []);

    const handleBrandChange = (event, newValue) => {
        setSelectedBrand(newValue);
    };

    const fetchData = async () => {
        setError(null);
        setIsLoading(true);
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };
            const requestData = {
                brand_id: selectedBrand?.id || "",
                is_active: false,
                pagination: perPage,
                page: page + 1,
            };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/admin-user-list`,

                requestData,
                config
            );
            const userList = response?.data?.data?.data || [];
            const mappedData = userList.map((item, index) => ({
                id: page * perPage + index + 1,
                admin_id: item.admin_id,
                username: item.username || "",
                admin_email: item.admin_email || "",
                user_level: item.user_level || "",
                status: item.status === 1 ? "Active" : "Inactive",
            }));
            setData(mappedData);
            setTotalCount(response?.data?.data?.total || 0);
            setSnackbarMessage(response.data.message);
            setSnackbarOpen(true);
        } catch (error) {
            console.error("Error fetching data:", error);
            setError(
                error?.response?.data?.message ||
                "An error occurred while fetching data."
            );
        } finally {
            setIsLoading(false);
        }
    };
    const source = axios.CancelToken.source();
    const sourceRef = useRef(null);
    useEffect(() => {
        sourceRef.current = axios.CancelToken.source();
        fetchData(
            perPage,
            page,
            search,
            totalCount,
            selectedBrand,
            sourceRef.current
        );
        return () => {
            sourceRef.current.cancel('Request canceled by cleanup');
        };
    }, [perPage, page,], 2000);

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate') {
            setFromDate(value);
        } else if (name === 'toDate') {
            setToDate(value);
        }
    };
    const handlePerPageChange = (e) => {
        setPerPage(Number(e.target.value));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setPage(0);
        setSelectedRows([]);
        fetchData(perPage, page, search, totalCount, selectedBrand,);
    };
    const clearForm = () => {
        window.location.reload();
        setSearch('');
    };
    const handleRowsSelect = (currentRowsSelected, allRowsSelected) => {
        setSelectedRows(allRowsSelected.map((row) => row.index));
    };
    const handleRowsDelete = (rowsDeleted) => {
        console.log('Rows to be deleted:', rowsDeleted);
    };
    const handleSubmits = async () => {
        if (!excutiveassign) {
            setSnackbarMessage("Please select Campaign ID");
            setSnackbarOpen(true);
            return;
        }
        if (!selectedBrand?.id) {
            setSnackbarMessage("Please select Brand");
            setSnackbarOpen(true);
            return;
        }
        setIsLoading(true);
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };
            const payload = {
                campaign_id: excutiveassign,
                brand_id: selectedBrand.id,
            };
            console.log("Payload:", payload);
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/assign-campagin-brand`,
                payload,
                config
            );
            console.log("API Response:", response.data);
            setMessage(response.data.message);
            setSnackbarMessage(response.data.message);
            setSnackbarOpen(true);
            // reset fields after success
            setExcutiveAssign("");
            setSelectedBrand(null);
            // refresh table if needed
            fetchData();
        } catch (error) {
            console.error("API Error:", error);
            setSnackbarMessage(
                error?.response?.data?.message || "Something went wrong"
            );
            setSnackbarOpen(true);
        } finally {
            setIsLoading(false);
        }
    };
    const columns = [
        {
            name: "id",
            label: "S/N",
            options: {
                filter: false,
                sort: true,
                setCellProps: () => ({
                    align: "center",
                })
            },
        },
        {
            name: "username",
            label: "Name",
            options: {
                filter: true,
            },
        },
        {
            name: "admin_email",
            label: "Email",
            options: {
                filter: true,
            },
        },
        {
            name: "user_level",
            label: "User Level",
            options: {
                filter: true,
                setCellProps: () => ({
                    align: "center",
                })
            },
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                setCellProps: () => ({
                    align: "center",
                })
            },
        },
        {
            name: "admin_id",
            label: "Assign Admin Role",
            options: {
                filter: false,
                sort: false,
                setCellProps: () => ({
                    align: "center",
                }),
                customBodyRender: (value) => (
                    <EditIcon
                        className={classes.tableiconedit}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenAssignRoleModal(value)}
                    />
                ),
            },
        },
        {
            name: "admin_id",
            label: "Assign Brands",
            options: {
                filter: false,
                sort: false,
                setCellProps: () => ({
                    align: "center",
                }),

                customBodyRender: (value) => (
                    <EditIcon
                        className={classes.tableiconedit}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenAssignBrandModal(value)}
                    />
                ),
            },
        },
        {
            name: "admin_id",
            label: "Update User Details",
            options: {
                filter: false,
                sort: false,
                setCellProps: () => ({
                    align: "center",
                }),
                customBodyRender: (value) => (
                    <EditIcon
                        className={classes.tableiconedit}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenUpdateUserModal(value)}
                    />
                ),
            },
        },

        {
            name: "admin_id",
            label: "Update Password",
            options: {
                filter: false,
                sort: false,
                setCellProps: () => ({
                    align: "center",
                }),
                customBodyRender: (value) => (
                    <LockOpenOutlinedIcon
                        className={classes.tableiconedit}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenPasswordModal(value)}
                    />
                ),
            },
        },
    ];
    const CustomToolbarAction = ({ toggleFilter }) => (
        <IconButton aria-label="Filter list" onClick={toggleFilter}>
            <FilterListIcon onClick={toggleSidebar} />
        </IconButton>
    );


    const toggleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };

    const handleRowClick = (rowIndex) => {
        const isSelected = selectedRows.includes(rowIndex);
        if (isSelected) {
            setSelectedRows(selectedRows.filter((row) => row !== rowIndex));
        } else {
            setSelectedRows([...selectedRows, rowIndex]);
        }
    };

    const options = {
        onRowClick: (rowData, rowMeta) => handleRowClick(rowMeta.dataIndex),
        selectableRows: 'multiple',
        onRowsSelect: handleRowsSelect,
        onRowsDelete: handleRowsDelete,
        rowsPerPage: perPage,
        selectableRows: 'none',
        page: page,
        serverSide: true,
        count: totalCount,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setPerPage(tableState.rowsPerPage);
                    setPage(0);
                    break;
                default:
                    break;
            }
        },

        customToolbar: () => <CustomToolbarAction />,
        filter: false,
        filterType: "dropdown",
        responsive: "standard",
        fixedHeader: true,
        fixedSelectColumn: true,
        overflowy: "auto",
        overflowx: "auto",
        rowsPerPageOptions: [10, 50, 100, 500, 1000, 10000, { value: totalCount, label: 'All' }],
        customFilterDialogFooter: (currentFilter, applyNewFilter) => (
            <div>
                <TextField
                    label="Filter Data"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    fullWidth
                />
                <Button onClick={applyNewFilter} variant="contained" color="primary">
                    Apply Filter
                </Button>
                <Button onClick={() => setOpenSidebar(false)} variant="contained" color="secondary">
                    Cancel
                </Button>
            </div>
        ),
        setRowProps: (row, dataIndex, rowIndex) => ({
            style: {
                backgroundColor: doubleClickedRow === rowIndex ? '#D2DE32' : selectedRows.includes(dataIndex) ? '#D2DE32' : 'inherit',
            },
            onDoubleClick: () => handleRowDoubleClick(row, rowIndex),
        }),

    };
    const currentTheme = customTheme(true);
    const classes = useStyles();
    const memoizedData = useMemo(() => data, [data]);
    const handleRowDoubleClick = (row, rowIndex) => {
        console.log("Row double-clicked:", row);
        console.log("Row index:", rowIndex);
        const updatedSelectedRows = [...selectedRows];
        const rowIndexInSelectedRows = updatedSelectedRows.indexOf(rowIndex);
        if (rowIndexInSelectedRows === -1) {
            updatedSelectedRows.push(rowIndex);
        } else {
            updatedSelectedRows.splice(rowIndexInSelectedRows, 1);
        }
        setSelectedRows(updatedSelectedRows);
    };

    const handleClosePopover = () => {
        setPopoverAnchor(null);
    };

    const handleInputChange = (e) => {
        setUpdatedData({
            ...updatedData,
            [e.target.name]: e.target.value,
        });

        if (e.target.name === 'status') {
            handleFormSubmit();
        }
    };
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            const updatedUserData = { ...selectedUser, ...updatedData };

            const response = await axios.post(`${API_BASE_URL}/api/admin/v2/bulk-status-change/${selectedUser.id}`, updatedUserData);
            console.log('User data updated:', updatedUserData);
            setMessage(response.data.message);
            handleClosePopover();
        } catch (error) {
            console.error('Error updating user data:', error);
        }
    };
    const statusOptions = ['Status', 'Busy', 'Not Connected', 'Switched Off', 'Wrong Number'];

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    return (
        <>
            {message && <p
                className={classes.message}
            >{message}</p>}
            <div>
                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <MuiAlert onClose={handleCloseSnackbar} severity="info" sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </MuiAlert>
                </Snackbar>
            </div>

            <Box sx={{ width: '100%' }}>
                <Grid container>
                    <Grid item xs={6} style={{ marginTop: "8px" }}>
                        <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>
                            Admin Users
                        </Typography>
                    </Grid>
                    <Grid item xs={6} style={{ margin: "auto", padding: "auto", textAlign: "right", marginBottom: "5px" }}>
                        <Button
                            onClick={() => setOpenCreateUserModal(true)}
                            style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                            className={classes.buttonform}
                            variant="outlined"
                            startIcon={<AddCircleIcon />}
                        >
                            Add Admin User
                        </Button>
                    </Grid>
                </Grid>
                <hr className={classes.horizontalline} />

            </Box>
            <MuiThemeProvider theme={customTheme()}>
                {
                    isLoading ? (
                        <LinearProgress />

                    ) : (
                        ""
                    )
                }
                <MUIDataTable
                    title={
                        isLoading ? (
                            <Skeleton animation="wave" />

                        ) : (
                            <Typography className={classes.tabletittle} >

                            </Typography>
                        )
                    } data={memoizedData}
                    columns={columns}
                    options={options}
                />

            </MuiThemeProvider>
            <Drawer anchor="right" open={openSidebar}

                PaperProps={{
                    style: {
                        width: "100%",
                        maxWidth: 300,
                        padding: "10px"
                    }
                }}

                onClose={() => setOpenSidebar(false)}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>

                            <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={12} >
                            <br />
                            <Typography className={classes.tabletittle} >
                                Filter
                            </Typography>
                        </Grid>
                    </Grid>
                    <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>
                        <div className={classes.root}>

                            <Grid container spacing={1}>
                                <Grid item xs={4} sm={2} lg={12} >
                                    <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />

                                </Grid>

                                <Grid item xs={4} sm={2} lg={12}>
                                    <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <br />
                    <Grid >
                        <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>
                            <Button
                                type='submit'
                                style={{ marginRight: "10px" }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ApprovalIcon />}>
                                Apply
                            </Button>
                            <Button
                                type="button" onClick={clearForm}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ClearIcon />}>
                                Clear
                            </Button>

                        </Grid>
                    </Grid>
                    <br />
                </form>
            </Drawer >

            <Popover
                open={Boolean(popoverAnchor)}
                anchorEl={popoverAnchor}
                onClose={handleClosePopover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {selectedUser && (
                    <div>
                        <form onSubmit={handleFormSubmit}>

                            <div style={{ display: "flex", padding: "10px" }}>
                                <label>
                                    <select
                                        style={{ width: "100px", marginRight: "10px" }}
                                        className={classes.selectform}
                                        name="status"
                                        value={updatedData.status}
                                        onChange={handleInputChange}
                                    >
                                        {statusOptions.map((status) => (
                                            <option key={status} value={status}>
                                                {status}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                                <Button
                                    style={{ marginRight: "10px" }}
                                    className={classes.buttonform}
                                    type="submit">Submit</Button>
                            </div>
                        </form>
                    </div>
                )}
            </Popover>

            <Modal
                open={openCreateUserModal}
                onClose={() => setOpenCreateUserModal(false)}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 900,
                        bgcolor: "background.paper",
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 3,
                    }}
                >
                    <Typography
                        variant="h6"
                        style={{ marginBottom: "5px" }}
                    >
                        Adding Admin User
                    </Typography>
                    <Divider
                        style={{
                            marginBottom: "20px",
                            backgroundColor: "#dcdcdc",
                            height: "1px",
                        }}
                    />

                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <label className={classes.labelform}>
                                User Name
                            </label>
                            <input
                                className={classes.inputform}
                                type="text"
                                name="username"
                                placeholder="Enter User name"
                                value={createUserForm.username}
                                onChange={handleCreateUserChange}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <label className={classes.labelform}>
                                Enter Email
                            </label>
                            <input
                                className={classes.inputform}
                                type="email"
                                name="admin_email"
                                placeholder="Enter Email"
                                value={createUserForm.admin_email}
                                onChange={handleCreateUserChange}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <label className={classes.labelform}>
                                Status
                            </label>
                            <select
                                className={classes.inputform}
                                name="user_level"
                                value={createUserForm.user_level}
                                onChange={handleCreateUserChange}
                            >
                                <option value="">Select User Level</option>
                                <option value="super">Super</option>
                                <option value="executive">Executive</option>
                                <option value="shop">Shop</option>
                            </select>
                        </Grid>

                        <Grid item xs={12}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "50px",
                                }}
                            >
                                <Button
                                    className={classes.buttonform}
                                    variant="outlined"
                                    onClick={handleCreateUserSubmit}
                                    disabled={isLoading}
                                    style={{ width: "100px", backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                >
                                    {isLoading ? "Creating..." : "Save"}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>

            <Modal
                open={openAssignRoleModal}
                onClose={() => setOpenAssignRoleModal(false)}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 600,
                        bgcolor: "background.paper",
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 3,
                    }}
                >
                    <Typography variant="h6" style={{ marginBottom: "5px" }}>
                        Assign Module
                    </Typography>
                    <Divider
                        style={{
                            marginBottom: "20px",
                            backgroundColor: "#dcdcdc",
                            height: "1px",
                        }}
                    />
                    <label className={classes.labelform}>
                        Select Module (Multiple Select)
                    </label>

                    <Autocomplete
                        classes={{
                            option: classes.autocompleteoption,
                        }}
                        multiple
                        disableCloseOnSelect
                        options={moduleList}
                        value={selectedModules}
                        onChange={handleModuleChange}
                        getOptionLabel={(option) => option.title}
                        isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                        }
                        getOptionSelected={(option, value) => option.id === value.id}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                {option.title}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Select Modules"
                            />
                        )}
                    />
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "100px",
                        }}
                    >
                        <Button
                            className={classes.buttonform}
                            style={{ width: "150px", backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                            variant="outlined"
                            onClick={handleAssignRolesSubmit}
                        >
                            Assign
                        </Button>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={openAssignBrandModal}
                onClose={() => setOpenAssignBrandModal(false)}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 600,
                        bgcolor: "background.paper",
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 3,
                    }}
                >
                    <Typography
                        variant="h6"
                        style={{ marginBottom: "5px" }}
                    >
                        Assigning Brands
                    </Typography>
                    <Divider
                        style={{
                            marginBottom: "20px",
                            backgroundColor: "#dcdcdc",
                            height: "1px",
                        }}
                    />
                    <label className={classes.labelform}>
                        Select Brands (Multiple Select)
                    </label>

                    <Autocomplete
                        classes={{
                            option: classes.autocompleteoption,
                        }}
                        multiple
                        disableCloseOnSelect
                        options={assignBrandOptions}
                        value={selectedAssignBrands}
                        onChange={(event, value) =>
                            setSelectedAssignBrands(value)
                        }
                        getOptionLabel={(option) => option.title}
                        isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                        }
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                <Checkbox checked={selected} />
                                {option.title}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Select Brands"
                            />
                        )}
                    />

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "80px",
                        }}
                    >
                        <Button
                            className={classes.buttonform}
                            style={{ width: "150px", backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                            variant="outlined"
                            onClick={handleAssignBrandSubmit}
                        >
                            Assign
                        </Button>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={openUpdateUserModal}
                onClose={() => setOpenUpdateUserModal(false)}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 800,
                        bgcolor: "background.paper",
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 3,
                    }}
                >
                    <Typography
                        variant="h6"
                        style={{ marginBottom: "5px" }}
                    >
                        Updating Admin User
                    </Typography>
                    <Divider
                        style={{
                            marginBottom: "20px",
                            backgroundColor: "#dcdcdc",
                            height: "1px",
                        }}
                    />
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <label className={classes.labelform}>
                                User Name
                            </label>
                            <input
                                className={classes.inputform}
                                type="text"
                                name="username"
                                placeholder="Enter User Name"
                                value={updateUserForm.username}
                                onChange={handleUpdateUserChange}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <label className={classes.labelform}>
                                Email
                            </label>
                            <input
                                className={classes.inputform}
                                type="email"
                                name="admin_email"
                                placeholder="Enter Email"
                                value={updateUserForm.admin_email}
                                onChange={handleUpdateUserChange}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <label className={classes.labelform}>
                                Status
                            </label>
                            <select
                                className={classes.inputform}
                                name="user_level"
                                value={updateUserForm.user_level}
                                onChange={handleUpdateUserChange}
                            >
                                <option value="">User Level</option>
                                <option value="super">Super</option>
                                <option value="executive">Executive</option>
                                <option value="shop">Shop</option>
                            </select>
                        </Grid>
                        <Grid item xs={12}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "80px",
                                }}
                            >
                                <Button
                                    className={classes.buttonform}
                                    style={{ width: "150px", backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                    variant="outlined"
                                    onClick={handleUpdateUserSubmit}
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Updating..." : "Save"}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
            <Modal
                open={openPasswordModal}
                onClose={() => setOpenPasswordModal(false)}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 600,
                        bgcolor: "background.paper",
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 3,
                    }}
                >
                    <Typography
                        variant="h6"
                        style={{ marginBottom: "5px" }}
                    >
                        Create Password
                    </Typography>
                    <Divider
                        style={{
                            marginBottom: "20px",
                            backgroundColor: "#dcdcdc",
                            height: "1px",
                        }}
                    />
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <label className={classes.labelform}>
                                New Password
                            </label>
                            <input
                                className={classes.inputform}
                                type="password"
                                name="new_password"
                                placeholder="Enter New Password"
                                value={passwordForm.new_password}
                                onChange={handlePasswordChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <label className={classes.labelform}>
                                Confirm Password
                            </label>
                            <input
                                className={classes.inputform}
                                type="password"
                                name="confirm_password"
                                placeholder="Enter Confirm Password"
                                value={passwordForm.confirm_password}
                                onChange={handlePasswordChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "80px",
                                }}
                            >
                                <Button
                                    className={classes.buttonform}
                                    style={{ width: "150px", backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                    variant="outlined"
                                    onClick={handlePasswordSubmit}
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Creating..." : "Create"}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    );
};

export default AllUsers;


